<template>
  <ParametrosAhorros />
</template>

<script>
import ParametrosAhorros from "../components/ParametrosAhorros";

export default {
  name: "Home",
  components: {
    ParametrosAhorros,
  },
};
</script>
